<template>
  <div>
    <SkipLinks />
    <ClientOnly>
      <AdminBar v-if="accessToolbar && !isEditing" />
    </ClientOnly>

    <div class="relative">
      <div id="header-container" class="bg-hero relative">
        <NuxtPageDependency>
          <SiteHeader />
          <VuepalBreadcrumb v-slot="{ links }">
            <Breadcrumb v-if="showBreadcrumb" :links />
          </VuepalBreadcrumb>
        </NuxtPageDependency>
      </div>

      <div>
        <ClientOnly>
          <DrupalMessages v-if="!isEditing" />
        </ClientOnly>
        <main id="main-content" tabindex="-1">
          <slot />
        </main>
      </div>
    </div>
    <PageFooter />
    <ClientOnly>
      <CookieBanner />
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
const route = useRoute()
const { accessToolbar } = await useDrupalUser()

const isEditing = computed(
  () => !!(route.query.blokkliEditing || route.query.blokkliPreview),
)

const showBreadcrumb = computed(() => route.meta.hideBreadcrumb !== true)
</script>
